<template>
  <div class="fixed-height" v-if="!props.noMargin"></div>
  <div class="fixed-footer-section fixed-height">
    <slot />
  </div>
</template>
<script setup lang="ts">
/* ------ THIS COMPONENT DISPLAYS LIST OF ITEMS HORIZONTALLY WITH SCROLL ------ */
const props = withDefaults(defineProps<{ sidebarWidth?: string; height?: string; noMargin?: boolean }>(), {
  sidebarWidth: '20rem',
  height: '76px',
  noMargin: false,
});
</script>
<style>
.fixed-height {
  height: v-bind('props.height');
  /* keep the in-flow spacer from collapsing under the fixed footer */
  flex-shrink: 0;
}

.fixed-footer-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  background-color: white;
  z-index: 1;
  border-top: 1px solid var(--Border, #eaecf0);
  box-shadow: 0px -3px 4px 0px #0000000a;
}

@media (min-width: 768px) {
  .fixed-footer-section {
    left: v-bind('props.sidebarWidth');
    z-index: 10;
  }
}
</style>
